'use client'
import * as React from 'react'
import classes from './styles.module.css'
import {usePathname, useRouter, useSearchParams} from 'next/navigation'

interface BlogFilterProps {
  getBlogsBySearch?: any
  setSearchedBlogs?: any
  setSearchText?: any
  categories: any
  serverSide?: boolean
}

const BlogFilter = ({categories, serverSide = false}: BlogFilterProps) => {
  const exception = ['All Products', 'Most Recent']
  const params = useSearchParams()
  const pathname = usePathname()
  const router = useRouter()

  // Extract category ID from pathname for server-side mode
  const activeCategoryId = React.useMemo(() => {
    if (serverSide) {
      // Check if pathname matches the category pattern
      const categoryMatch = pathname.match(/\/blogs\/category\/(\d+)/)
      return categoryMatch ? categoryMatch[1] : null
    } else {
      // Use query parameter for client-side mode
      return params.get('category')
    }
  }, [pathname, params, serverSide])

  // Update the handleTagChange function in BlogFilter
  const handleTagChange = (filter: {name: string; id: string}) => {
    if (serverSide) {
      if (filter?.name === 'All') {
        router.push('/blogs', {scroll: false})
      } else {
        router.push(`/blogs/category/${filter?.id}`, {scroll: false})
      }
    } else {
      const category = params.get('category')
      if (filter?.name === 'All' && category !== null) {
        router.push(pathname, {scroll: false})
      }
      if (filter?.name !== 'All' && category !== filter?.id) {
        router.push(`${pathname}?category=${filter?.id}`, {scroll: false})
      }
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>Latest Blogs</div>
      <div className={classes.filters}>
        {[{name: 'All', id: 'all', slug: 'all'}, ...structuredClone(categories || [])?.reverse()]
          ?.filter(category => !exception.includes(category.name))
          .map(filter => (
            <div
              key={filter.id}
              className={`${classes.filter} ${
                activeCategoryId == filter.id ||
                (filter.name === 'All' && activeCategoryId === null)
                  ? classes.active
                  : ''
              }`}
              onClick={() => handleTagChange(filter)}
            >
              {filter.name}
            </div>
          ))}
      </div>
    </div>
  )
}

const BlogFilterWrapper = ({
  getBlogsBySearch,
  setSearchedBlogs,
  setSearchText,
  categories,
  serverSide = false,
}: BlogFilterProps) => {
  return (
    <React.Suspense>
      <BlogFilter
        getBlogsBySearch={getBlogsBySearch}
        setSearchedBlogs={setSearchedBlogs}
        setSearchText={setSearchText}
        categories={categories}
        serverSide={serverSide}
      />
    </React.Suspense>
  )
}

export default BlogFilterWrapper
